import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

import type { Language } from "models";

export type Establishment = {
  Id: number;
  Name: string;
  DealerLocationID: number;
};

const component = "LocationsOverviewDashboardQueryKeys";

export const LocationsOverviewDashboardQueryKeys = {
  languages: backendQueryKey<Language[]>({ component, baseUrl: ENV.systemBaseURL, endpoint: "/languages/list" }),
  planItEstablishmentIds: backendQueryKey<Establishment[]>({ component, baseUrl: ENV.dealerBaseURL, endpoint: "/planit/locations" })
};
